// extracted by mini-css-extract-plugin
module.exports = {"container":"_911b137","resultsContainer":"_8a0aea2","title":"_74d5ff5","showMore":"_223a599"};